import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Evaluation } = await import('./index');
    return {
        Component: Evaluation,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
